import { motion } from "framer-motion";

export const PageHero = ({ kicker, title, copy, dark = true, testid }) => (
    <section
        data-testid={testid}
        className={`relative overflow-hidden pt-36 md:pt-44 pb-16 md:pb-24 ${
            dark ? "bg-ink tent-stripes text-white" : "bg-paper tent-stripes-light text-ink"
        }`}
    >
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7 }}
                className="font-manrope text-xs md:text-sm font-bold tracking-[0.4em] uppercase text-pink mb-5"
            >
                {kicker}
            </motion.p>
            <h1 className="font-oswald uppercase leading-[0.88] tracking-tight text-5xl sm:text-7xl lg:text-8xl">
                <span className="mask-line">
                    <motion.span
                        initial={{ y: "115%" }}
                        animate={{ y: "0%" }}
                        transition={{ delay: 0.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        className="block"
                    >
                        {title}
                    </motion.span>
                </span>
            </h1>
            {copy && (
                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.7 }}
                    className={`mt-6 max-w-xl text-base md:text-lg leading-relaxed ${dark ? "text-zinc-400" : "text-zinc-500"}`}
                >
                    {copy}
                </motion.p>
            )}
        </div>
    </section>
);
